import React, { useEffect } from "react";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap";
import "./css/app.css";

import { ProtectedRoute } from "./core/protected.route";
import ErrorBoundary from "./core/ErrorBoundary";
import {
  BrowserRouter as Router,
  withRouter,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import GridView from "./view/uiProfile/pageView/grid";
import { ListView } from "./view/uiProfile/pageView/list";
import Map_view from "./view/uiProfile/pageView/map_view";
import { Info } from "./view/uiProfile/pageView/info";
import liveDisplay from "./view/uiProfile/pageView/display";
import notfound from "./view/uiProfile/pageView/404";
import Navbar from "./view/uiProfile/pageView/navbar";
import Login from "./view/uiProfile/pageView/login";

import FU from "./view/uiProfile/pageView/firmwareupgrade";
import Histo from "./view/uiProfile/pageView/history";
import { ES } from "./view/uiProfile/pageView/editsite";
import { AddSite } from "./view/uiProfile/pageView/AddSite";
import { AddAccount } from "./view/uiProfile/pageView/AddAccount";
import { Parameters } from "./view/uiProfile/pageView/parameters";
import { Faults } from "./view/uiProfile/pageView/faults";
import { Update } from "./view/uiProfile/pageView/update";
import Activateaccount from "./view/uiProfile/pageView/activateaccount";
import Forgetpass from "./view/uiProfile/pageView/forgetpass";
import { Home } from "./view/uiProfile/pageView/home";
import COND05 from "./view/uiProfile/readingView/COND05";
import Mobiledisplay from "./view/uiProfile/readingView/mobiledisplay";
import { Logs } from "./view/uiProfile/pageView/logs";

function App(props) {
  //const mapView = mapView(); <meta name="viewport" content=" width=device-width. user-scalable=no"></meta>
  const location = useLocation();

  const ismobiledisplaypath =
    location.pathname === "/mobiledisplay" ||
    location.pathname.includes("/mobiledisplay/mac");
  if (ismobiledisplaypath) {
    document.body.classList.toggle("no-padding-top", ismobiledisplaypath);

    // <-- Add the meta tag here
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    if (!viewportMeta) {
      viewportMeta = document.createElement("meta");
      viewportMeta.name = "viewport";
      viewportMeta.content = "width=device-width, initial-scale=1";
      document.head.appendChild(viewportMeta);
    } else {
      viewportMeta.content = "width=device-width, initial-scale=1";
    }
    return (
      <React.Fragment>
        <div className="App">
          <Switch>
            <Route
              exact
              path="/Surf/mobiledisplay/mac:mac/siteid:siteid/designtype:designtype"
              component={Mobiledisplay}
            />
            <Route path="*" component={notfound} />
          </Switch>
        </div>
      </React.Fragment>
    );
  } else {
    return (
      <Router basename="/Surf">
        <React.Fragment>
          <div className="App">
            <Navbar {...props} />
            <Switch>
              <Route
                exact
                path="/Activate-Account"
                component={Activateaccount}
              />
              <Route exact path="/Forgetpass" component={Forgetpass} />

              <ProtectedRoute exact path="/grid" component={GridView} />
              <ProtectedRoute exact path="/list" component={ListView} />
              <ProtectedRoute exact path="/map" component={Map_view} />
              <ProtectedRoute
                exact
                path="/ld"
                component={(props) => (
                  <ErrorBoundary>
                    {React.createElement(liveDisplay, props)}
                  </ErrorBoundary>
                )}
              />
              <ProtectedRoute exact path="/info" component={Info} />
              <ProtectedRoute exact path="/firmwareUpgrade" component={FU} />
              <ProtectedRoute exact path="/logs" component={Logs} />
              <ProtectedRoute exact path="/edit" component={ES} />
              <ProtectedRoute exact path="/param" component={Parameters} />
              <ProtectedRoute exact path="/fault" component={Faults} />
              <ProtectedRoute exact path="/update" component={Update} />
              <Route exact path="/COND05" component={COND05} />
              <ProtectedRoute exact path="/Add-Site" component={AddSite} />
              <ProtectedRoute exact path="/home" component={Home} />
              <Route exact path="/Add-Account" component={AddAccount} />
              <Route exact path="/" component={Login} />
              <Route path="*" component={notfound} />
            </Switch>
            <footer
              className="page-footer font-small"
              style={{
                background: "rgb(246,246,247)",
                background:
                  "linear-gradient(0deg, rgba(246,246,247,1) 0%, rgba(255,255,255,1) 100%)",
              }}
            >
              <p className="footer-copyright text-center py-3">
                <img
                  src={require("./images/Logo Mark.png")}
                  style={{ height: "5rem", width: "5rem" }}
                />
                <br />
                <a href="https://sascontrollers.com/">
                  {" "}
                  www.sascontrollers.com
                </a>
                <br />© 2026 Copyright: Designed and developed by S.& A.S.Co.Ltd
              </p>
              <hr />
            </footer>
          </div>
        </React.Fragment>
      </Router>
    );
  }
}

export default withRouter(App);
